<template>
    <div>

        <a @click.prevent="editItem = true" href="#" class="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">
            <!-- Heroicon name: pencil-alt -->
            <svg class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                <path fill-rule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clip-rule="evenodd" />
            </svg>
            Edit
        </a>

        <div v-if="editItem" class="bg-blue-50 border-blue-400 rounded-lg my-4 pt-8 pb-5 px-5 relative">
            <!-- This example requires Tailwind CSS v2.0+ -->
            <div class="fixed z-10 inset-0 overflow-y-auto">
                <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <div class="fixed inset-0 transition-opacity" aria-hidden="true" @click="editItem = false">
                        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                    </div>

                    <!-- This element is to trick the browser into centering the modal contents. -->
                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                    <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all ease-out duration-300 sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                        <div class="flex justify-between items-center mb-4  bg-blue-50 border-b border-blue-100 p-4">
                            <p class="text-xl font-semibold text-blue-900">Edit Item</p>
                            <svg @click="editItem = false" class="w-6 h-6 text-gray-400 cursor-pointer hover:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                        </div>
                        <div class="px-4 pt-5 pb-4 sm:p-6">
                            <form  @submit.prevent="submit" class="grid grid-cols-9 gap-6">
                                <div class="col-span-9 sm:col-span-3">
                                    <label for="quantity" class="block text-sm font-medium text-gray-700">Bid Qty</label>
                                    <text-input v-model="item.quantity" type="number" step="1" name="quantity" id="quantity" class="mt-1" />
                                </div>
                                <div class="col-span-9 sm:col-span-3">
                                    <label for="price" class="block text-sm font-medium text-gray-700">Bid Price</label>
                                    <text-input v-model="item.price" type="number" step=".01" name="price" id="price" class="mt-1" />
                                </div>
                                <div class="col-span-9 sm:col-span-3">
                                    <label for="expires_at" class="block text-sm font-medium text-gray-700">Expires Date</label>
                                    <text-input v-model="item.expires_at" type="date" name="expires_at" id="expires_at" class="mt-1" />
                                </div>
                                <div class="col-span-9 sm:col-span-3">
                                    <label for="expires_at_time" class="block text-sm font-medium text-gray-700">Expires Time</label>
                                    <text-input v-model="expiresAtTime" type="time" name="expires_at_time" id="expires_at_time" class="mt-1" />
                                </div>
                                <div class="col-span-9 sm:col-span-4">
                                    <label for="transport" class="block text-sm font-medium text-gray-700">Transport</label>
                                    <text-input v-model="item.transport" type="text" name="transport" id="transport" class="mt-1" />
                                </div>
                                <div class="col-span-9 sm:col-span-4">
                                    <label for="location" class="block text-sm font-medium text-gray-700">Location</label>
                                    <text-input v-model="item.location" type="text" name="location" id="location" class="mt-1" />
                                </div>
                                <div class="col-span-9 sm:col-span-4">
                                    <label for="shipment_period" class="block text-sm font-medium text-gray-700">Period</label>
                                    <text-input v-model="item.shipment_period" type="text"  name="shipment_period" id="shipment_period" class="mt-1" />
                                </div>
                                <div class="col-span-12">
                                    <label for="comments" class="block text-sm font-medium text-gray-700">Comments</label>
                                    <textarea v-model="item.comments" ref="comments" id="comments" name="comments" rows="3" class="mt-2 shadow-sm block w-full focus:ring-blue-500 focus:border-blue-500 font-mono sm:text-sm border-gray-300 rounded-md"></textarea>
                                </div>
                                <div class="col-span-9 grid grid-cols-2 gap-6 border border-gray-300 rounded-lg p-2" style="min-height:278px">
                                    <div class="p-4">
                                        <label class="block text-sm font-medium text-gray-700">Assignees</label>
                                        <ul class=" mt-2">
                                            <li v-for="(assignee, idx) in assignees" :key="assignee.id" class="flex justify-between items-center p-2 border-b border-gray-100">
                                                <span class="text-xs">{{ assignee.name }}</span>
                                                <button @click="removeAssignee(assignee, assignee.type, idx)" type="button" class="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-gray-500 hover:text-red-500 bg-gray-50 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                                    </svg>
                                                </button>
                                            </li>
                                        </ul>
                                        <div v-if="assignees.length === 0" class="text-center mt-4">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="mx-auto h-12 w-12 text-gray-400"  fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                            </svg>
                                            <h3 class="mt-2 text-sm font-medium text-gray-900">No assignees.</h3>
                                            <p class="mt-1 text-sm text-gray-500">
                                                Get started by adding zones or gins.
                                            </p>
                                        </div>
                                    </div>

                                    <div v-if="showGins" class="p-4">
                                        <div class="flex justify-between">
                                            <label class="block text-sm font-medium text-gray-700">Gins</label>
                                            <svg @click="showGins = false" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-500 hover:text-gray-700 cursor-pointer" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>
                                        </div>
                                        <div class="my-1 bg-gray-50 w-full h-48 overflow-y-auto px-4 py-2">
                                            <ul>
                                                <li v-for="(gin, idx) in sortedGins" :key="gin.id" class="flex items-center py-1.5">
                                                    <a @click.prevent="addAssignee(gin, 'gin', idx)" href="#" class="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-blue-100">
                                                        Add
                                                    </a>
                                                    <span class="ml-1.5 text-xs truncate ...">{{ gin.gin_number }} {{ gin.name }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div v-if="showZones" class="p-4">
                                        <div class="flex justify-between">
                                            <label class="block text-sm font-medium text-gray-700">Zones</label>
                                            <svg @click="showZones = false" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-500 hover:text-gray-700 cursor-pointer" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>
                                        </div>
                                        <div class="my-1 bg-gray-50 w-full h-48 overflow-y-auto px-4 py-2">
                                            <ul>
                                                <li v-for="(zone, idx) in sortedZones" :key="zone.id" class="flex items-center py-1.5">
                                                    <a @click.prevent="addAssignee(zone, 'zone', idx)" href="#" class="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-blue-100">
                                                        Add
                                                    </a>
                                                    <span class="ml-1.5 text-xs truncate ...">{{ zone.name }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div v-if="! showGins && ! showZones" class="justify-start items-center flex flex-col">
                                        <button @click="showZones = true" type="button" class="mt-12 w-32 inline-flex items-center px-4 py-3 border border-transparent shadow-sm text-sm font-medium rounded-md border-2 border-blue-500 text-blue-600 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="-ml-1 mr-2 h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                                            </svg>
                                            Add Zone
                                        </button>
                                        <button @click="showGins = true" type="button" class="mt-3 w-32 inline-flex items-center px-4 py-3 border border-transparent shadow-sm text-sm font-medium rounded-md border-2 border-blue-500 text-blue-600 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="-ml-1 mr-2 h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                            </svg>
                                            Add Gin
                                        </button>
                                    </div>
                                </div>
                                <div class="col-span-9 flex justify-end items-center t-6">
                                    <loading-button :loading="saving"  type="submit" class="">
                                        Save
                                    </loading-button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LoadingButton from "@/Shared/LoadingButton";
import TextInput from '@/Shared/TextInput'

export default {
    components: { LoadingButton, TextInput },
    props: {
        item: {
            type: Object,
            required: true,
        },
        gins: {
            type: Array,
            required: true,
        },
        zones: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            saving: false,
            editItem: false,
            showGins: false,
            showZones: false,
            assignees: [],
            mutableGins: this.gins,
            mutableZones: this.zones,
            updatedItem: {},
            expiresAtTime: '',
        }
    },

    methods: {
        addAssignee(obj, type, idx) {
            obj.type = type
            this.assignees.push(obj)
            if (type === 'gin') {
                this.mutableGins.splice(idx, 1)
            } else {
                this.mutableZones.splice(idx, 1)
            }
        },
        removeAssignee(obj, type, idx) {
            this.assignees.splice(idx, 1)
            if (type === 'gin') {
                this.mutableGins.push(obj)
            } else {
                this.mutableZones.push(obj)
            }
        },
        submit() {
            this.updatedItem = this.item
            this.updatedItem.assignees = this.assignees
            this.updatedItem.expires_at_time = this.expiresAtTime
            this.$inertia.put(this.route('settings.cottonseed-bids.update', this.updatedItem.id), this.updatedItem, {
                onStart: () => this.saving = true,
                onFinish: () => this.saving = false,
                onSuccess: () => this.editItem = false,
            })
        }
    },
    watch: {
        editItem() {
            if (this.editItem) {
                this.$nextTick(() => {
                    let date = new Date(this.item.expires_at);
                    this.expiresAtTime = this.item.expires_at.split(' ')[1].slice(0, -3);
                    this.item.expires_at = date.toISOString().split('T')[0];
                    this.item.zones.forEach(zone => {
                        zone.type = 'zone'
                        let foundZoneIndex = this.mutableZones.findIndex(item => item.id === zone.id)
                        if (foundZoneIndex > -1) {
                            this.mutableZones.splice(foundZoneIndex, 1)
                        }
                    })
                    this.item.gins.forEach(gin => {
                        gin.type = 'gin'
                        let foundGinIndex = this.mutableGins.findIndex(item => item.id === gin.id)
                        if (foundGinIndex > -1) {
                            this.mutableGins.splice(foundGinIndex, 1)
                        }
                    });
                    this.assignees = [...this.item.zones, ...this.item.gins]
                })
            } else {
                this.$emit('close-menu')
            }
        }
    },
    computed: {
        sortedGins() {
            return this.mutableGins.sort((a, b) => (a.name > b.name) ? 1 : -1)
        },
        sortedZones() {
            return this.mutableZones.sort((a, b) => (a.name > b.name) ? 1 : -1)
        }
    }
}
</script>
